export default __webpack_public_path__ + "images/ban-user-icon.svg";